module.exports = __webpack_public_path__ + "img/2_inspection-sp.84a0b5c5.jpg";